/* eslint-disable @typescript-eslint/no-empty-function */
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { updateRoute } from 'state/application/reducer'
import { useAppDispatch } from 'state/hooks'

// Functional link component which delays page navigation
export const DelayLink = (props) => {
  const dispatch = useAppDispatch()
  const { delay, onDelayStart, onDelayEnd, replace, to, ...rest } = props
  let timeout = null
  let history = useHistory()
  let location = useLocation()

  useEffect(() => {
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [timeout])

  const handleClick = (e) => {
    let _delay = delay
    // if trying to navigate to current page stop everything
    if (location?.pathname === to) return
    dispatch(updateRoute({ to }))
    if (location?.pathname !== '/roulette') {
      _delay = 0
    }

    onDelayStart(e, to)
    if (e.defaultPrevented) {
      return
    }

    e.preventDefault()

    timeout = setTimeout(() => {
      if (replace) {
        history.replace(to)
      } else {
        history.push(to)
      }
      onDelayEnd(e, to)
    }, _delay)
  }

  return <Link {...rest} to={to} onClick={handleClick} />
}

DelayLink.propTypes = {
  // Milliseconds to wait before registering the click.
  delay: PropTypes.number,
  // Called after the link is clicked and before the delay timer starts.
  onDelayStart: PropTypes.func,
  // Called after the delay timer ends.
  onDelayEnd: PropTypes.func,
  // Replace history or not
  replace: PropTypes.bool,
  // Link to go to
  to: PropTypes.string,
}

DelayLink.defaultProps = {
  replace: false,
  delay: 0,
  onDelayStart: () => {},
  onDelayEnd: () => {},
}

export default DelayLink
